import { ApplicationSection } from "@prisma/client";
import axios from "axios";

import { ApplicationSectionFull } from "@/lib/prisma";

export const saveApplicationSection = async (
  applicationId: string,
  data: ApplicationSection,
  isDeleting?: boolean
): Promise<ApplicationSectionFull> => {
  return await axios
    .post(
      `${process.env.NEXT_PUBLIC_API_URL}/application/${applicationId}/section`,
      {
        ...data,
        isDeleting,
      }
    )
    .then((res) => res.data);
};
